<script>
import VClamp from 'vue-clamp';
import { newsRelated } from '../api/news';

export default {
  name: 'CpLatestNews',
  components: {
    CpButton: require('../button').default,
    handleImageError: require('../mixins/utils').default,
    CpShowImageInCard: require('../components/ShowImageInCard').default,
    VClamp,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginLeft: require('../directives/margins').marginLeft,
  },
  props: {
    newsId: [String, Number],
  },
  mounted() {
    this.getLatestNews();
  },
  data() {
    return {
      latestNews: [],
    };
  },
  methods: {
    getLatestNews() {
      newsRelated(this.newsId)
        .then(response => {
          this.latestNews = response.news_related;
        })
        .catch(error => {
          console.warn(error);
        });
    },
  },
};
</script>
<template>
  <div v-if="latestNews && latestNews.length">
    <h3 class="H3 black-color" v-margin-top="0">Latest News</h3>
    <a v-for="(item, index) in latestNews" :key="item.id" :href="`/news/${item.id}`" v-margin-left="0.5" class="newsItemContainer">
      <p class="caption1 neutral6-color text-center" v-margin-top="0">
        <VClamp autoresize :max-lines="3">{{ item.title }}</VClamp>
      </p>
      <span v-if="item.image" class="imageContainer">
        <CpShowImageInCard :image="item.image" />
      </span>
      <div v-if="index < latestNews.length - 1" class="separator"></div>
    </a>
  </div>
</template>

<style scoped>
.newsItemContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  cursor: pointer;
}

.newsItemContainer:hover {
  background-color: var(--primary-blue-100);
  border-radius: 4px;
}

.newsItemContainer:hover p {
  color: var(--primary);
}

.newsImage {
  background: var(--primary1);
  margin-right: 10px;
  border-radius: 50%;
}

.imageContainer {
  margin-bottom: 16px;
}

.separator {
  width: 30%;
  margin: 4px 0;
  height: 1px;
  background-color: var(--neutral3);
}
@media screen and (max-width: 768px) {
  .imageContainer {
    width: 75%;
  }
}
</style>
